<template>
  <!-- 组件 -->
  <div class="bottom_bar">
    <!-- 友情链接 -->
    <!-- <div class="links">
      友情链接： **渣土资源交易平台 | **电子采招交易平台 | **网络货运平台 | **运营监管服务平台 | **渣土资源交易平台 | **电子采招交易平台 | **网络货运平台 | **运营监管服务平台
    </div> -->
    <!-- 底部栏 -->
    <div class="bottom_bar">
      <div class="bottom_content">
        <div class="bottom_we">
          <div class="about_us">关于我们</div>
          <div class="company_profile">公司简介</div>
          <div class="contact_us">联系我们 </div>
        </div>
        <div class="split_line"></div>
        <div class="service">
          <div class="support">服务与支持</div>
          <div class="cooperation">合作加盟</div>
          <div class="guide">服务指南</div>
          <!-- <div class="download">APP下载</div> -->
        </div>    
        <div class="message_board">
          <div class="message_title">留言板</div>
          <div class="name">
            姓名
            <div class="input_name">
              <input v-model="name" class="input" type="text">
            </div>
          </div>
          <div class="phone">
            电话
            <div class="input_phone">
              <input v-model="phone" class="input" type="number">
            </div>
          </div>
          <div class="content">
            内容
            <div class="input_content">
              <textarea v-model="content" class="input" type="text" id=""></textarea>
            </div>
          </div>
          <div class="submit" @click="submit">
            提交
          </div>
        </div>
        <div class="follow_us">
          <div class="follow">关注我们</div>
          <div class="follow_mailbox">
            <img class="mailbox_img" src="/static/img/index/letter.png" alt="">
            邮箱：public@xiaolvt.com
          </div>
          <div class="follow_phone">
            <img class="phone_img" src="/static/img/index/phone.png" alt="">
            电话：0532-86416789
          </div>
          <div class="follow_website">
            <img class="website_img" src="/static/img/index/network.png" alt="">
            网址：http://www.xiaolvt.com
          </div>
          <div class="follow_address">
            <img class="address_img" src="/static/img/index/position.png" alt="">
            地址：山东省青岛市城阳区城阳街道春阳路92号29号楼703
          </div>
        </div>
        <div class="small_green">
          <img class="green_img" src="/static/img/index/officialAccount.png" alt="">
          <div class="green_public">小绿微信公众号</div>
          <div class="green_welcome">欢迎关注</div>
        </div>
      </div>
      <div class="keep_on_record">
        Copyright 2013  小绿（青岛）环境科技有限公司  All rights reserved     
        &nbsp;
        <!-- <img class="record_img" src="static/img/common/gongan.png" alt=""> -->
        <a class="record_text" style="color:#80807F" href="http://beian.miit.gov.cn" rel="noffolw" target="_blank">
          鲁ICP备2023014515号
        </a>
      </div>
      <!-- <div class="public">
        <a target="_blank" 
          class="put_on_file"
          href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=37021302001026">
          <img src="static/img/common/gongan.png" class="record_img"/>
          <p class="public_word">
            鲁公网安备 37021302001026号
          </p>
        </a>
      </div> -->
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      name:'',
      phone:'',
      content:''
    };
  },
  //过滤器
  filters: {},
  // 计算属性
  computed: {},
  // 监听器
  Watch: {},
  //生命周期 创建后
  created() {},
  // 挂载后
  mounted() {},
  // 销毁前
  beforeDestroy() {},
  //自定义函数
  methods: {
    submit(){
      if(!this.name){
        this.$message({
          showClose: true,
          message: '请输入姓名',
          center: true,
          type: 'error'
        });
        return
      }
      if(!this.phone){
        this.$message({
          showClose: true,
          message: '请输入电话',
          center: true,
          type: 'error'
        });
        return
      }
      if(!this.content){
        this.$message({
          showClose: true,
          message: '请输入内容',
          center: true,
          type: 'error'
        });
        return
      }
      this.name=''
      this.phone=''
      this.content=''
      this.$message({
        showClose: true,
        message: '提交成功，感谢您的留言',
        center: true,
        type: 'success'
      }); 

    }
  },
};
</script>

<style scoped lang="scss">
.bottom_bar{
  display: flex;
  flex-direction: column;
  justify-content: center;

  @media screen and ( min-width: 1200px ) {
    .links{
      // margin-top: 60px;
      width: 1920px;
      height: 60px;
      background-image: url('/static/img/index/friendly_tips.png');
      background-size: 100% 100%;
      padding-left: 360px;
      box-sizing: border-box;
      display: flex;
      align-items: center;
      font-weight: 400;
      font-size: 12px;
      color: #2E3037;
    }

    .bottom_bar{
      width: 1920px;
      background: #2E3037;
      .bottom_content{
        display: flex;
        .bottom_we{
          margin: 46px 0 0 202px;
          .about_us{
            font-size: 14px;
            color: #FFFFFF;
          }
          .company_profile{
            margin-top: 15px;
            font-size: 12px;
            color: #AAAAAA;
          }
          .contact_us{
            margin-top: 15px;
            font-size: 12px;
            color: #AAAAAA;
          }
        }
        .split_line{
          margin: 46px 0 0 100px;
          width: 1px;
          height: 206px;
          background: #AAAAAA;
        }
        .service{
          margin: 46px 0 0 100px;
          .support{
            font-weight: 500;
            font-size: 14px;
            color: #FFFFFF;
          }
          .cooperation{
            margin-top: 15px;
            font-size: 12px;
            color: #AAAAAA;
          }
          .guide{
            margin-top: 15px;
            font-size: 12px;
            color: #AAAAAA;
          }
          .download{
            margin-top: 15px;
            font-size: 12px;
            color: #AAAAAA;
          }
        }
        .message_board{
          margin: 46px 0 0 120px;
          .message_title{
            font-weight: 500;
            font-size: 14px;
            color: #FFFFFF;
          }
          .name{
            margin-top: 15px;
            font-size: 12px;
            font-weight: 400;
            color: #AAAAAA;
            display: flex;
            align-items: center;
            .input_name{
              margin-left: 12px;    
              width: 300px;
              height: 30px;      
              background: rgba(255, 255, 255, 0.04);
              border: 1px solid rgba(170, 170, 170, 0.5);
              border-radius: 4px;
            }
          }
          .phone{
            margin-top: 10px;
            font-size: 12px;
            font-weight: 400;
            color: #AAAAAA;
            display: flex;
            align-items: center;
            .input_phone{
              margin-left: 12px;    
              width: 300px;
              height: 30px;      
              background: rgba(255, 255, 255, 0.04);
              border: 1px solid rgba(170, 170, 170, 0.5);
              border-radius: 4px;
            }
          }
          .content{
            margin-top: 10px;
            font-size: 12px;
            font-weight: 400;
            color: #AAAAAA;
            display: flex;
            .input_content{
              margin-left: 12px;    
              width: 300px;
              height: 86px;      
              background: rgba(255, 255, 255, 0.04);
              border: 1px solid rgba(170, 170, 170, 0.5);
              border-radius: 4px;
            }
          }
          .input{
            width: 100%;
            height: 100%;
            border: 0;
            outline: none;
            resize:none;
            color: #ffffff;
            background-color: rgba(255, 255, 255, 0);
          }
          input::-webkit-inner-spin-button {
            -webkit-appearance: none;
          }
          input[type="number"]{
            -moz-appearance: textfield;
          }
          input::-webkit-input-placeholder { 
            /* WebKit browsers，webkit内核浏览器 */
            color: #BFBFBF;
            font-size: 12px;
          } 
          input:-moz-placeholder { 
          /* Mozilla Firefox 4 to 18 */ 
            color: #BFBFBF;
            font-size: 12px;
          } 
          input::-moz-placeholder { 
          /* Mozilla Firefox 19+ */ 
            color: #BFBFBF;
            font-size: 12px;
          } 
          input:-ms-input-placeholder { 
          /* Internet Explorer 10+ */ 
            color: #BFBFBF;
            font-size: 12px;
          }
          /* 设置textarea框提示内容的样式 */
          textarea::-webkit-input-placeholder{
            color: #BFBFBF;
            font-size: 12px;
          }/*webkit 内核浏览器*/
          textarea::-moz-placeholder{
            color: #BFBFBF;
            font-size: 12px;
          }/*Mozilla Firefox 19+*/
          textarea:-moz-placeholder{
            color: #BFBFBF;
            font-size: 12px;
          }/*Mozilla Firefox 4 to 18*/
          textarea:-ms-input-placeholder{
            color: #BFBFBF;
            font-size: 12px;
          }
          .submit{
            width: 300px;
            height: 35px;
            background: rgba(255, 255, 255, 0.08);
            display: flex;
            align-items: center;
            justify-content: center;
            margin-top: 12px;
            margin-left: 38px;
            font-weight: 500;
            font-size: 12px;
            color: #FFFFFF;
          }
          .submit:hover{
            background-color: #0EA049;
            cursor: pointer;
          }
        }
        
        .follow_us{
          margin: 46px 0 0 120px;
          width: 430px;
          .follow{
            font-weight: 500;
            font-size: 14px;
            color: #FFFFFF;
          }
          .follow_mailbox{
            font-weight: 400;
            font-size: 12px;
            color: #AAAAAA;
            margin-top: 20px;
            display: flex;
            align-items: center;
            .mailbox_img{
              width: 16px;
              height: 16px;
              margin-right: 10px;
            }
          }
          .follow_phone{
            font-weight: 400;
            font-size: 12px;
            color: #AAAAAA;
            margin-top: 20px;
            display: flex;
            align-items: center;
            .phone_img{
              width: 16px;
              height: 16px;
              margin-right: 10px;

            }
          }
          .follow_website{
            font-weight: 400;
            font-size: 12px;
            color: #AAAAAA;
            margin-top: 20px;
            display: flex;
            align-items: center;
            .website_img{
              width: 16px;
              height: 16px;
              margin-right: 10px;

            }
          }
          .follow_address{
            font-weight: 400;
            font-size: 12px;
            color: #AAAAAA;
            margin-top: 20px;
            line-height: 22px;
            display: flex;
            width: 360px;
            .address_img{
              width: 16px;
              height: 16px;
              margin-right: 10px;
              margin-top: 4px;
            }
          }
        }
        .small_green{
          text-align: center;
          margin: 46px 0 0 6px;
          .green_img{
            width: 103px;
            height: 103px;
          }
          .green_public{
            font-weight: 400;
            font-size: 12px;
            color: #AAAAAA;
          }
          .green_welcome{
            margin-top: 4px;
            font-weight: 400;
            font-size: 12px;
            color: #AAAAAA;
            
          }
        } 
      }
      .keep_on_record{
        width: 1560px;
        height: 57px;
        border-top: 1px solid #AAAAAA;
        display: flex;
        align-items: center;
        justify-content: center ;
        margin: 23px 180px 0 180px;
        font-weight: 500;
        font-size: 12px;
        color: #80807F;
        .record_text{
          display: flex;
          align-items: center;       
        } 
      }
      .public{
        .put_on_file{
          display:inline-block;
          text-decoration:none;
          line-height:20px;
          display: flex;
          align-items: center;
          justify-content: center;
          margin-bottom: 16px;
          .record_img{
            height: 16px;
          }  
          .public_word{
            font-size: 12px;
            line-height:20px;
            margin: 0px 0px 0px 5px; 
            color: #80807F; 
          }
        }
      }
    }
  }
  @media screen and ( min-width: 1000px ) and ( max-width: 1200px ) {
    .links{
      // margin-top: 3.75rem;
      width: 120rem;
      height: 3.75rem;
      background-image: url('/static/img/index/friendly_tips.png');
      background-size: 100% 100%;
      padding-left: 22.5rem;
      box-sizing: border-box;
      display: flex;
      align-items: center;
      font-weight: 400;
      font-size: .75rem;
      color: #2E3037;
    }

    .bottom_bar{
      width: 120rem;
      background: #2E3037;
      .bottom_content{
        display: flex;
        .bottom_we{
          margin: 2.875rem 0 0 12.625rem;
          .about_us{
            font-size: .875rem;
            color: #FFFFFF;
          }
          .company_profile{
            margin-top: .9375rem;
            font-size: .75rem;
            color: #AAAAAA;
          }
          .contact_us{
            margin-top: .9375rem;
            font-size: .75rem;
            color: #AAAAAA;
          }
        }
        .split_line{
          margin: 2.875rem 0 0 6.25rem;
          width: .0625rem;
          height: 12.875rem;
          background: #AAAAAA;
        }
        .service{
          margin: 2.875rem 0 0 6.25rem;
          .support{
            font-weight: 500;
            font-size: .875rem;
            color: #FFFFFF;
          }
          .cooperation{
            margin-top: .9375rem;
            font-size: .75rem;
            color: #AAAAAA;
          }
          .guide{
            margin-top: .9375rem;
            font-size: .75rem;
            color: #AAAAAA;
          }
          .download{
            margin-top: .9375rem;
            font-size: .75rem;
            color: #AAAAAA;
          }
        }
        .message_board{
          margin: 2.875rem 0 0 7.5rem;
          .message_title{
            font-weight: 500;
            font-size: .875rem;
            color: #FFFFFF;
          }
          .name{
            margin-top: .9375rem;
            font-size: .75rem;
            font-weight: 400;
            color: #AAAAAA;
            display: flex;
            align-items: center;
            .input_name{
              margin-left: .75rem;    
              width: 18.75rem;
              height: 1.875rem;      
              background: rgba(255, 255, 255, 0.04);
              border: .0625rem solid rgba(170, 170, 170, 0.5);
              border-radius: .25rem;
            }
          }
          .phone{
            margin-top: .625rem;
            font-size: .75rem;
            font-weight: 400;
            color: #AAAAAA;
            display: flex;
            align-items: center;
            .input_phone{
              margin-left: .75rem;    
              width: 18.75rem;
              height: 1.875rem;      
              background: rgba(255, 255, 255, 0.04);
              border: .0625rem solid rgba(170, 170, 170, 0.5);
              border-radius: .25rem;
            }
          }
          .content{
            margin-top: .625rem;
            font-size: .75rem;
            font-weight: 400;
            color: #AAAAAA;
            display: flex;
            .input_content{
              margin-left: .75rem;    
              width: 18.75rem;
              height: 5.375rem;      
              background: rgba(255, 255, 255, 0.04);
              border: .0625rem solid rgba(170, 170, 170, 0.5);
              border-radius: .25rem;
            }
          }
          .input{
            width: 100%;
            height: 100%;
            border: 0;
            outline: none;
            resize:none;
            color: #ffffff;
            background-color: rgba(255, 255, 255, 0);
          }
          input::-webkit-inner-spin-button {
            -webkit-appearance: none;
          }
          input[type="number"]{
            -moz-appearance: textfield;
          }
          input::-webkit-input-placeholder { 
            /* WebKit browsers，webkit内核浏览器 */
            color: #BFBFBF;
            font-size: .75rem;
          } 
          input:-moz-placeholder { 
          /* Mozilla Firefox 4 to 18 */ 
            color: #BFBFBF;
            font-size: .75rem;
          } 
          input::-moz-placeholder { 
          /* Mozilla Firefox 19+ */ 
            color: #BFBFBF;
            font-size: .75rem;
          } 
          input:-ms-input-placeholder { 
          /* Internet Explorer 10+ */ 
            color: #BFBFBF;
            font-size: .75rem;
          }
          /* 设置textarea框提示内容的样式 */
          textarea::-webkit-input-placeholder{
            color: #BFBFBF;
            font-size: .75rem;
          }/*webkit 内核浏览器*/
          textarea::-moz-placeholder{
            color: #BFBFBF;
            font-size: .75rem;
          }/*Mozilla Firefox 19+*/
          textarea:-moz-placeholder{
            color: #BFBFBF;
            font-size: .75rem;
          }/*Mozilla Firefox 4 to 18*/
          textarea:-ms-input-placeholder{
            color: #BFBFBF;
            font-size: .75rem;
          }
          .submit{
            width: 18.75rem;
            height: 2.1875rem;
            background: rgba(255, 255, 255, 0.08);
            display: flex;
            align-items: center;
            justify-content: center;
            margin-top: .75rem;
            margin-left: 2.375rem;
            font-weight: 500;
            font-size: .75rem;
            color: #FFFFFF;
          }
          .submit:hover{
            background-color: #0EA049;
            cursor: pointer;
          }
        }
        
        .follow_us{
          margin: 2.875rem 0 0 7.5rem;
          width: 26.875rem;
          .follow{
            font-weight: 500;
            font-size: .875rem;
            color: #FFFFFF;
          }
          .follow_mailbox{
            font-weight: 400;
            font-size: .75rem;
            color: #AAAAAA;
            margin-top: 1.25rem;
            display: flex;
            align-items: center;
            .mailbox_img{
              width: 1rem;
              height: 1rem;
              margin-right: .625rem;
            }
          }
          .follow_phone{
            font-weight: 400;
            font-size: .75rem;
            color: #AAAAAA;
            margin-top: 1.25rem;
            display: flex;
            align-items: center;
            .phone_img{
              width: 1rem;
              height: 1rem;
              margin-right: .625rem;

            }
          }
          .follow_website{
            font-weight: 400;
            font-size: .75rem;
            color: #AAAAAA;
            margin-top: 1.25rem;
            display: flex;
            align-items: center;
            .website_img{
              width: 1rem;
              height: 1rem;
              margin-right: .625rem;

            }
          }
          .follow_address{
            font-weight: 400;
            font-size: .75rem;
            color: #AAAAAA;
            margin-top: 1.25rem;
            line-height: 1.375rem;
            display: flex;
            width: 22.5rem;
            .address_img{
              width: 1rem;
              height: 1rem;
              margin-right: .625rem;
              margin-top: .25rem;
            }
          }
        }
        .small_green{
          text-align: center;
          margin: 2.875rem 0 0 .375rem;
          .green_img{
            width: 6.4375rem;
            height: 6.4375rem;
          }
          .green_public{
            font-weight: 400;
            font-size: .75rem;
            color: #AAAAAA;
          }
          .green_welcome{
            margin-top: .25rem;
            font-weight: 400;
            font-size: .75rem;
            color: #AAAAAA;
            
          }
        } 
      }
      .keep_on_record{
        width: 97.5rem;
        height: 3.5625rem;
        border-top: .0625rem solid #AAAAAA;
        display: flex;
        align-items: center;
        justify-content: center ;
        margin: 1.4375rem 11.25rem 0 11.25rem;
        font-weight: 500;
        font-size: .75rem;
        color: #80807F;
        .record_text{
          display: flex;
          align-items: center;       
        } 
      }
      .public{
        .put_on_file{
          display:inline-block;
          text-decoration:none;
          line-height:1.25rem;
          display: flex;
          align-items: center;
          justify-content: center;
          margin-bottom: 1rem;
          .record_img{
            height: 1rem;
          }  
          .public_word{
            font-size: .75rem;
            line-height:1.25rem;
            margin: 0rem 0rem 0rem .3125rem; 
            color: #80807F; 
          }
        }
      }
    }
  }
  @media screen and ( max-width: 1000px ) {
    .links{
      display: none;
    }
    .bottom_bar{
      width: 23.4375rem;
      background: #2E3037;
      .bottom_content{
        display: flex;
        .bottom_we{
          display: none;
        }
        .split_line{
          display: none;
        }
        .service{
          display: none;
        }
        .message_board{
          display: none;
        }
        
        .follow_us{
          margin: .75rem 0 0 1rem;
          // width: 6880px; 
          .follow{
            font-weight: 400;
            font-size: .875rem;
            color: #FFFFFF;
          }
          .follow_mailbox{
            font-weight: 400;
            font-size: .75rem;
            color: #AAAAAA;
            margin-top: .75rem;
            display: flex;
            align-items: center;
            .mailbox_img{
              display: none;
              width: .3125rem;
              height: .25rem;
              margin-right: .1875rem;
            }
          }
          .follow_phone{
            font-weight: 400;
            font-size: .75rem;
            color: #AAAAAA;
            margin-top: .75rem;
            display: flex;
            align-items: center;
            .phone_img{
              display: none;
              width: .3125rem;
              height: .25rem;
              margin-right: .1875rem;

            }
          }
          .follow_website{
            font-weight: 400;
            font-size: .75rem;
            color: #AAAAAA;
            margin-top: .75rem;
            display: flex;
            align-items: center;
            .website_img{
              display: none;
              width: .3125rem;
              height: .25rem;
              margin-right: .1875rem;
            }
          }
          .follow_address{
            width: 21.3125rem;
            font-weight: 400;
            font-size: .75rem;
            color: #AAAAAA;
            margin-top: .75rem;
            display: flex;
            .address_img{
              display: none;
              width: .3125rem;
              height: .25rem;
              margin-right: .1875rem;
              margin-top: .0625rem;
            }
          }
        }
        .small_green{
          text-align: center;
          margin: .875rem 0 0 .125rem;
          position: absolute;
          right: 1.875rem;
          .green_img{
            width: 6.6875rem;
          }
          .green_public{
            display: none;
          }
          .green_welcome{
            display: none;
          }
        } 
      }
      .keep_on_record{
        width: 21.4375rem;
        padding: 0.7rem 0;
        box-sizing: border-box;
        border-top: .0625rem solid #AAAAAA;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        margin: 0.5rem 1rem 0.25rem 1rem;
        font-weight: 500;
        font-size: .75rem;
        color: #80807F; 
        text-align: center;
        .record_text{
          display: flex;
          align-items: center;
          white-space: nowrap;        
        }
      }
      .public{
        .put_on_file{
          display:inline-block;
          text-decoration:none;
          line-height:1.25rem;
          display: flex;
          align-items: center;
          justify-content: center;
          margin-bottom: 1rem;
          .record_img{
            height: 1rem;
          }  
          .public_word{
            font-size: .75rem;
            line-height:1.25rem;
            margin: 0rem 0rem 0rem .3125rem; 
            color: #80807F; 
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/bottomBar.vue